module.exports = __webpack_public_path__ + "img/footer-icono-tel.debf4f70.svg";